import React, { Component } from 'react';
import ExpenseTypeStep5Page  from './expense-types-step5-html';
class ExpenseTypeStep5 extends Component {
    constructor(props){
        super(props)
        window.scrollTo({top: 0, behavior: 'smooth'})
    }
    render() {
        return(
            <div>
                <ExpenseTypeStep5Page
                />
            </div>
        )
    }
}
export default ExpenseTypeStep5;